import $ from 'jquery';
import  AmenityMap from './mapscripts/src/am_amenity_map.js';
import AmenityAccordion from './mapscripts/src/am_amenity_accordion.js';

class BjzmMaps {

	constructor() {
		console.log('im the beginning of the mpap stuss');
		new AmenityMap();
		new AmenityAccordion();
	}

}

module.exports = BjzmMaps;